import { FetchRequest } from '@rails/request.js';
import { modalContainer } from './modal-mount';

export { modalContainer };

export async function openModal(url) {
  const request = new FetchRequest('get', url, { responseKind: 'html' });
  const response = await request.perform();
  if (!response.ok) {
    return null;
  }

  const container = modalContainer();
  container.insertAdjacentHTML('beforeend', await response.html);

  return container.lastElementChild;
}
